import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { tipoClassificacaoCadastroCliente, tipoClassificacaoCadastroItem } from '../tipo-classificacao-cadastro';
import { TipoClassificacaoCadastroPipe } from '../pipes';

@Component({
    selector: 'sgt-tipo-classificacao-cadastro-multiselect',
    templateUrl: './tipo-classificacao-cadastro-multiselect.component.html',
    styleUrls: ['./tipo-classificacao-cadastro-multiselect.component.less']
})
export class TipoClassificacaoCadastroMultiselectComponent implements OnInit {
    /** Cadastros selecionados */
    @Input() cadastros: number[];
    /** Ao alterar a seleção dos cadastros */
    @Output() cadastrosChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Cadastro';
    @Input() checked = 'Cadastro'
    @Input() checkedPlural = 'Cadastros';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum cadastro encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowCliente = true;
    @Input() isShowItem = true;
    // Options
    options: IMultiSelectOption[];

    constructor(private tipoClassificacaoCadastroPipe: TipoClassificacaoCadastroPipe) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-tipo-classificacao-cadastro ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os cadastros para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        if (this.isShowCliente) {
            selects.push({
                id: tipoClassificacaoCadastroCliente.id,
                name: tipoClassificacaoCadastroCliente.nome,
                classes: 'multiselect-item-tipo-classificacao-cadastro multiselect-item-tipo-classificacao-cadastro-cliente'
            });
        }
        if (this.isShowItem) {
            selects.push({
                id: tipoClassificacaoCadastroItem.id,
                name: tipoClassificacaoCadastroItem.nome,
                classes: 'multiselect-item-tipo-classificacao-cadastro multiselect-item-tipo-classificacao-cadastro-item'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção dos cadastros */
    onChange() {
        this.cadastrosChange.emit(this.cadastros);
    }
}
